import {Loader, LoaderOptions} from 'google-maps';
import { MarkerClusterer } from "@googlemaps/markerclusterer";

class Map {
	constructor(config) {
		this.config = Object.assign({
			scope: '#map',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		const options = {};
		this.markers = [];
		this.loader = new Loader(google_api_key, options);
		this.initMap();
		this.infoWindow();
	}

	async initMap() {
		this.google = await this.loader.load();
		this.map = new this.google.maps.Map(document.getElementById('map'), {
			center: {lat: 52.25, lng: 5.40},
			zoom: 8,
			styles: [{
				stylers: [{
					saturation: -100
				}]
			}]
		})

		this.initMarkers();
	}

	render({ count, position }, stats) {
		// change color if this cluster has more markers than the mean cluster
		// const color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff";
		const color = "#000000";
		// create svg url with fill color
		const svg = window.btoa(`
		  <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
			<circle cx="120" cy="120" opacity=".6" r="70" />
			<circle cx="120" cy="120" opacity=".3" r="90" />
			<circle cx="120" cy="120" opacity=".2" r="110" />
		  </svg>`);

		return new google.maps.Marker({
			position,
			icon: {
				url: `data:image/svg+xml;base64,${svg}`,
				scaledSize: new google.maps.Size(45, 45),
			},
			label: {
				text: String(count),
				color: "rgba(255,255,255,0.9)",
				fontSize: "12px",
			},
			title: `Cluster of ${count} markers`,
			// adjust zIndex to be above other markers
			zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
		});
	}

	initMarkers() {

		let premiumicon = {
			path: "M68.9,38.2c-0.7-1.5-2.5-2.4-4.9-2.4c-0.8,0-1.6,0.1-2.4,0.2v0c-1,0.3-2,0.6-2.9,1c0.7-1.4,1-2.9,1.2-4.4l0-0.1l0-0.1\n" +
				"\tc-0.2-1-0.3-2.1-0.4-3.2c-0.1-1-0.2-2-0.3-3.1l0-0.1c-1-3.3-2-6.8-3.1-10.2c0-1.6,0-3.1,0-4.7v-0.3l-0.2-0.2\n" +
				"\tc-1.2-1.4-2.4-2.8-3.7-4.2c-0.2-0.3-0.5-0.7-0.8-1.1C49.9,3.3,47.8,0,42.6,0c-0.2,0-0.4,0-0.6,0c-3,0.2-5.8,1.2-8.2,3\n" +
				"\tc-1.2,0.9-2.5,1.6-3.9,2.1c-0.7,0.2-1.3,0.4-2,0.4c-1.5,0.2-3,0.5-3.8,1.3L24.1,7L24,7.2l-0.9,3.1c-0.2,0.1-0.4,0.1-0.6,0.2\n" +
				"\tc-1.8,0.6-4.9,1.5-9.4,6c-3.2,3-8.7,9.3-10.6,17.3c-1.5,6.6-1.8,10.6-1.2,15c0,1.6-0.2,3.1-0.6,4.7c-0.3,1.3-0.5,2.7-0.5,4.1\n" +
				"\tc0,0.4,0,1-0.1,1.6c-0.2,3.1-0.3,5.5,0.8,6.4c0.4,0.3,1,0.5,3.2,0.5c1.9,0,4.3-0.1,6.2-0.3c1.1-0.1,2-0.1,2.5-0.1l0.8,0v0h0.7\n" +
				"\tc5.6,0,11.2,0,16.9,0h1.1l-0.5-1c-0.7-1.5-1.4-3.1-2.1-4.7c-1.7-4.3-2.2-9-1.4-13.5l2-0.8c0.3,2,1.7,3.9,2.9,5.7\n" +
				"\tc1.2,1.8,2.5,3.7,2.1,4.7c-0.2,0.2-0.5,0.3-0.7,0.5c-0.7,0.3-1.3,0.8-1.6,1.5c-0.4,1.2-0.1,2.6,0.7,3.6c1.3,1.9,3.3,3.1,5.6,3.2\n" +
				"\tc0.4,0,0.8-0.1,1.2-0.2c4.5-1.3,3-9.9,1.3-16.4c1.6-0.1,3.2-0.6,4.7-1.3c0,0,0.8-0.4,2.3-1.3c-0.7,1.9-2.2,3.7-5.7,3.7h-0.7l0,0.7\n" +
				"\tc0.2,1.8,0.7,3.5,1.3,5.2l0.3,0.6l0.6-0.2c0.4-0.1,0.7-0.4,1-0.6c0.2-0.2,0.5-0.4,0.8-0.4c2.9-0.8,5.2-3.2,6.5-4.6\n" +
				"\tc1.2-1.5,2.1-3.1,2.7-4.9c0.4-0.9,0.8-1.8,1.3-2.7l0-0.1c0-0.1,0.1-0.2,0.1-0.3c0.5,0.3,1,0.6,1.4,0.8l0.8-1.1L58,40.3l0.3-0.1\n" +
				"\tc1.1-0.5,2.3-1,3.5-1.3c2.9-0.7,4.9-0.7,6.3,0.3l0.6,0.4l0.2-0.8c0-0.1,0-0.2,0.1-0.3l0-0.2L68.9,38.2z M43.1,37.5\n" +
				"\tc0.6-0.4,1.2-0.9,1.7-1.5l0-0.1c0.2-0.4,0.4-0.7,0.6-1.1l0.1-0.2l4.1,2.7c0.4,2,0.3,3.5-0.2,4.2l-0.2,0.3c-0.9,0.4-1.9,0.6-2.9,0.6\n" +
				"\tc-0.9,0-1.8-0.3-2.4-0.9c-0.9-1.1-1.3-2.4-1.2-3.8L43.1,37.5z M13.5,60.6c0,1.5,0.1,2.9,0,4.4l-0.2-0.3c-2.3-3.7-2.3-8.4,0-12.1\n" +
				"\tc0.1-0.1,0.1-0.2,0.2-0.3C13.4,55,13.5,57.8,13.5,60.6z",
			fillColor: '#A09263',
			fillOpacity: 1,
			scale: 0.5,
		}
		let icon = {
			path: "M68.9,38.2c-0.7-1.5-2.5-2.4-4.9-2.4c-0.8,0-1.6,0.1-2.4,0.2v0c-1,0.3-2,0.6-2.9,1c0.7-1.4,1-2.9,1.2-4.4l0-0.1l0-0.1\n" +
				"\tc-0.2-1-0.3-2.1-0.4-3.2c-0.1-1-0.2-2-0.3-3.1l0-0.1c-1-3.3-2-6.8-3.1-10.2c0-1.6,0-3.1,0-4.7v-0.3l-0.2-0.2\n" +
				"\tc-1.2-1.4-2.4-2.8-3.7-4.2c-0.2-0.3-0.5-0.7-0.8-1.1C49.9,3.3,47.8,0,42.6,0c-0.2,0-0.4,0-0.6,0c-3,0.2-5.8,1.2-8.2,3\n" +
				"\tc-1.2,0.9-2.5,1.6-3.9,2.1c-0.7,0.2-1.3,0.4-2,0.4c-1.5,0.2-3,0.5-3.8,1.3L24.1,7L24,7.2l-0.9,3.1c-0.2,0.1-0.4,0.1-0.6,0.2\n" +
				"\tc-1.8,0.6-4.9,1.5-9.4,6c-3.2,3-8.7,9.3-10.6,17.3c-1.5,6.6-1.8,10.6-1.2,15c0,1.6-0.2,3.1-0.6,4.7c-0.3,1.3-0.5,2.7-0.5,4.1\n" +
				"\tc0,0.4,0,1-0.1,1.6c-0.2,3.1-0.3,5.5,0.8,6.4c0.4,0.3,1,0.5,3.2,0.5c1.9,0,4.3-0.1,6.2-0.3c1.1-0.1,2-0.1,2.5-0.1l0.8,0v0h0.7\n" +
				"\tc5.6,0,11.2,0,16.9,0h1.1l-0.5-1c-0.7-1.5-1.4-3.1-2.1-4.7c-1.7-4.3-2.2-9-1.4-13.5l2-0.8c0.3,2,1.7,3.9,2.9,5.7\n" +
				"\tc1.2,1.8,2.5,3.7,2.1,4.7c-0.2,0.2-0.5,0.3-0.7,0.5c-0.7,0.3-1.3,0.8-1.6,1.5c-0.4,1.2-0.1,2.6,0.7,3.6c1.3,1.9,3.3,3.1,5.6,3.2\n" +
				"\tc0.4,0,0.8-0.1,1.2-0.2c4.5-1.3,3-9.9,1.3-16.4c1.6-0.1,3.2-0.6,4.7-1.3c0,0,0.8-0.4,2.3-1.3c-0.7,1.9-2.2,3.7-5.7,3.7h-0.7l0,0.7\n" +
				"\tc0.2,1.8,0.7,3.5,1.3,5.2l0.3,0.6l0.6-0.2c0.4-0.1,0.7-0.4,1-0.6c0.2-0.2,0.5-0.4,0.8-0.4c2.9-0.8,5.2-3.2,6.5-4.6\n" +
				"\tc1.2-1.5,2.1-3.1,2.7-4.9c0.4-0.9,0.8-1.8,1.3-2.7l0-0.1c0-0.1,0.1-0.2,0.1-0.3c0.5,0.3,1,0.6,1.4,0.8l0.8-1.1L58,40.3l0.3-0.1\n" +
				"\tc1.1-0.5,2.3-1,3.5-1.3c2.9-0.7,4.9-0.7,6.3,0.3l0.6,0.4l0.2-0.8c0-0.1,0-0.2,0.1-0.3l0-0.2L68.9,38.2z M43.1,37.5\n" +
				"\tc0.6-0.4,1.2-0.9,1.7-1.5l0-0.1c0.2-0.4,0.4-0.7,0.6-1.1l0.1-0.2l4.1,2.7c0.4,2,0.3,3.5-0.2,4.2l-0.2,0.3c-0.9,0.4-1.9,0.6-2.9,0.6\n" +
				"\tc-0.9,0-1.8-0.3-2.4-0.9c-0.9-1.1-1.3-2.4-1.2-3.8L43.1,37.5z M13.5,60.6c0,1.5,0.1,2.9,0,4.4l-0.2-0.3c-2.3-3.7-2.3-8.4,0-12.1\n" +
				"\tc0.1-0.1,0.1-0.2,0.2-0.3C13.4,55,13.5,57.8,13.5,60.6z",
			fillColor: '#000000',
			fillOpacity: 1,
			scale: 0.5,
		}
		let plusicon = {
			path: "M68.9,38.2c-0.7-1.5-2.5-2.4-4.9-2.4c-0.8,0-1.6,0.1-2.4,0.2v0c-1,0.3-2,0.6-2.9,1c0.7-1.4,1-2.9,1.2-4.4l0-0.1l0-0.1\n" +
				"\tc-0.2-1-0.3-2.1-0.4-3.2c-0.1-1-0.2-2-0.3-3.1l0-0.1c-1-3.3-2-6.8-3.1-10.2c0-1.6,0-3.1,0-4.7v-0.3l-0.2-0.2\n" +
				"\tc-1.2-1.4-2.4-2.8-3.7-4.2c-0.2-0.3-0.5-0.7-0.8-1.1C49.9,3.3,47.8,0,42.6,0c-0.2,0-0.4,0-0.6,0c-3,0.2-5.8,1.2-8.2,3\n" +
				"\tc-1.2,0.9-2.5,1.6-3.9,2.1c-0.7,0.2-1.3,0.4-2,0.4c-1.5,0.2-3,0.5-3.8,1.3L24.1,7L24,7.2l-0.9,3.1c-0.2,0.1-0.4,0.1-0.6,0.2\n" +
				"\tc-1.8,0.6-4.9,1.5-9.4,6c-3.2,3-8.7,9.3-10.6,17.3c-1.5,6.6-1.8,10.6-1.2,15c0,1.6-0.2,3.1-0.6,4.7c-0.3,1.3-0.5,2.7-0.5,4.1\n" +
				"\tc0,0.4,0,1-0.1,1.6c-0.2,3.1-0.3,5.5,0.8,6.4c0.4,0.3,1,0.5,3.2,0.5c1.9,0,4.3-0.1,6.2-0.3c1.1-0.1,2-0.1,2.5-0.1l0.8,0v0h0.7\n" +
				"\tc5.6,0,11.2,0,16.9,0h1.1l-0.5-1c-0.7-1.5-1.4-3.1-2.1-4.7c-1.7-4.3-2.2-9-1.4-13.5l2-0.8c0.3,2,1.7,3.9,2.9,5.7\n" +
				"\tc1.2,1.8,2.5,3.7,2.1,4.7c-0.2,0.2-0.5,0.3-0.7,0.5c-0.7,0.3-1.3,0.8-1.6,1.5c-0.4,1.2-0.1,2.6,0.7,3.6c1.3,1.9,3.3,3.1,5.6,3.2\n" +
				"\tc0.4,0,0.8-0.1,1.2-0.2c4.5-1.3,3-9.9,1.3-16.4c1.6-0.1,3.2-0.6,4.7-1.3c0,0,0.8-0.4,2.3-1.3c-0.7,1.9-2.2,3.7-5.7,3.7h-0.7l0,0.7\n" +
				"\tc0.2,1.8,0.7,3.5,1.3,5.2l0.3,0.6l0.6-0.2c0.4-0.1,0.7-0.4,1-0.6c0.2-0.2,0.5-0.4,0.8-0.4c2.9-0.8,5.2-3.2,6.5-4.6\n" +
				"\tc1.2-1.5,2.1-3.1,2.7-4.9c0.4-0.9,0.8-1.8,1.3-2.7l0-0.1c0-0.1,0.1-0.2,0.1-0.3c0.5,0.3,1,0.6,1.4,0.8l0.8-1.1L58,40.3l0.3-0.1\n" +
				"\tc1.1-0.5,2.3-1,3.5-1.3c2.9-0.7,4.9-0.7,6.3,0.3l0.6,0.4l0.2-0.8c0-0.1,0-0.2,0.1-0.3l0-0.2L68.9,38.2z M43.1,37.5\n" +
				"\tc0.6-0.4,1.2-0.9,1.7-1.5l0-0.1c0.2-0.4,0.4-0.7,0.6-1.1l0.1-0.2l4.1,2.7c0.4,2,0.3,3.5-0.2,4.2l-0.2,0.3c-0.9,0.4-1.9,0.6-2.9,0.6\n" +
				"\tc-0.9,0-1.8-0.3-2.4-0.9c-0.9-1.1-1.3-2.4-1.2-3.8L43.1,37.5z M13.5,60.6c0,1.5,0.1,2.9,0,4.4l-0.2-0.3c-2.3-3.7-2.3-8.4,0-12.1\n" +
				"\tc0.1-0.1,0.1-0.2,0.2-0.3C13.4,55,13.5,57.8,13.5,60.6z",
			fillColor: '#ffffff',
			fillOpacity: 1,
			scale: 0.5,
		}
		let icons = [];
		icons['premiumicon'] = premiumicon;
		icons['icon'] = icon;
		icons['plusicon'] = plusicon;

        var bounds = new this.google.maps.LatLngBounds();
        
		jQuery('div.dealer-overview div.card').each(function (it, el) {
			if (typeof jQuery(el).data('latitude') != 'undefined') {
				let lat = parseFloat(jQuery(el).data('latitude'));
				let lng = parseFloat(jQuery(el).data('longitude'));

				if(!isNaN(lat) && !isNaN(lng)) {
                	let marker = new this.google.maps.Marker({
						position: {
							lat: parseFloat(jQuery(el).data('latitude')),
							lng: parseFloat(jQuery(el).data('longitude'))
						},
						map: this.map,
						infoWindowHtml: jQuery(el).find('.info-window-html').html(),
						icon: icons[jQuery(el).find('.icon-therdex').attr('data-icon')] ?? icon
					});
					this.markers.push(marker);
                	bounds.extend(marker.position);
				}
			}
		}.bind(this));

        //now fit the map to the newly inclusive bounds
        this.map.fitBounds(bounds);

		// Add a marker clusterer to manage the markers.
		let markers = this.markers;
		let map = this.map;

		new MarkerClusterer({
			markers: markers,
			map: map,
			renderer: this
		});
	}

	infoWindow() {
		setTimeout(() => {
			// one instance of infowindow so we don't have multiple info windows open
			let infowindow = new this.google.maps.InfoWindow();
			this.markers.forEach((el, it) => {
				google.maps.event.addListener(el, 'click', () => {
					infowindow.setContent(el.infoWindowHtml);
					infowindow.open(this.map, el);
				});
			})
		}, 1000)
	}
}

export default new Map();